import { render } from "./TaskCard.vue?vue&type=template&id=dd7c91f2&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=dd7c91f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd7c91f2"

export default script